// DEV-16469: Fix metrics models and api
export class MetricsAccountPlanModel {
    id;
    name;
    token;
    createdAt;
    dpm;
    planUTS;
    active;
    suspended;
    dailyUsage;
    authorizedAccounts;
    dataStoreType;
    maxUniqueMetrics;
}
class DayUsage {
    date;
    dpm;
    hourlyAverageUTS;
}
class Account {
    accountId;
    accountName;
}
//# sourceMappingURL=metrics-account-plan.js.map